import { render, staticRenderFns } from "./DrinkCoachAppointment.vue?vue&type=template&id=2caf277d&scoped=true&"
import script from "./DrinkCoachAppointment.vue?vue&type=script&lang=ts&"
export * from "./DrinkCoachAppointment.vue?vue&type=script&lang=ts&"
import style0 from "./DrinkCoachAppointment.vue?vue&type=style&index=0&id=2caf277d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf277d",
  null
  
)

export default component.exports